// Copyright (c) 2016 Deere & Company

import decimalFormats from '../utils/decimal-formats';

export const buildNumberString = (decimalFormat, number, options) => {

    const displayFormats = {
        EMPTY: number.toLocaleString('de', options),
        X: number.toLocaleString('en', options),
        Y: number.toLocaleString('fr', options)
    };

    return decimalFormats.includes(decimalFormat) ? displayFormats[decimalFormat] : displayFormats.X;

};



// WEBPACK FOOTER //
// ./src/shared/services/build-number-string.js